module.exports = __webpack_public_path__ + "images/goods-details-icon-share.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/goods-details-icon-share.png
// module id = 854
// module chunks = 125